export const REF_NAME = 'COMMONCOUNTERPARTIES';
export const REF_PATH = 'commoncounterparties';
export const NAME = 'Common counterparties';
